import { FC } from 'react';

const DocumentsSpinner: FC = () => (
  <div className="spinner-border spinner-border-sm" role="status" />
);

export default DocumentsSpinner;
